import { List, ListItem, ListItemText } from '@mui/material'

import colors from '@/assets/scss/_themes-vars.module.scss'

export function Info({ name, description }: { name: string; description?: string }) {
  return (
    <List component="div" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
      <ListItem sx={{ width: 'auto' }}>
        <ListItemText
          primary={name}
          secondary={description}
          sx={{
            '& .MuiListItemText-primary': {
              color: colors.gray900,
              fontSize: '18px',
              fontWeight: 'bold',
            },
            '& .MuiListItemText-secondary': {
              color: colors.indigo700,
              fontSize: '14px',
              fontWeight: 'bold',
            },
          }}
        />
      </ListItem>
    </List>
  )
}
